import script from "./BondsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BondsDetail.vue?vue&type=script&setup=true&lang=js"

import "./BondsDetail.vue?vue&type=style&index=0&id=104a70be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104a70be"]])

export default __exports__